import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:/workSpacke/screening-sys/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es6.regexp.replace";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import request from "@/utils/request";

/**
 * * * 账号管理
 */

// 获取账户列表
export function accountList(data) {
  return request({
    url: "accountList",
    method: "post",
    data: data
  });
}

// 添加/修改账号
export function editAccount(data) {
  return request({
    url: "editAccount",
    method: "post",
    data: data
  });
}
// 管理-编辑学校账号信息

export function editAccountByAdmin(data) {
  return request({
    url: "editAccountByAdmin",
    method: "post",
    data: data
  });
}

// 删除账号
export function delAccount(data) {
  return request({
    url: "editAccount",
    method: "post",
    data: data
  });
}

/**
 * * * 学校管理
 */

// 获取学校列表
export function schoolList(params) {
  return request({
    url: "schoolList",
    method: "get",
    params: params
  });
}
export function schoolList2(data) {
  return request({
    url: "schoolList2",
    method: "post",
    data: data
  });
}

// 医院管理的学校列表（下拉选择）模糊查询
export function getSchools(params) {
  return request({
    url: "getSchools",
    method: "get",
    params: params
  });
}

// 添加/修改学校
export function editSchool(data) {
  return request({
    url: "editSchool",
    method: "post",
    data: data
  });
}

// 删除学校
export function delSchool(params) {
  return request({
    url: "delSchool",
    method: "get",
    params: params
  });
}

/**
 * * * 学生档案管理
 */

// 获取所有筛查计划名称（下拉选择）
export function getPlans(params) {
  return request({
    url: "getPlans",
    method: "get",
    params: params
  });
}
// 获取所有筛查计划名称（下拉选择）
export function getSchoolPlans(data) {
  return request({
    url: "getSchoolPlans",
    method: "get",
    params: data
  });
}

// 获取学校列表
export function fileList(data) {
  return request({
    url: "findArchivesByPlan",
    method: "post",
    data: data
  });
}

// 获取视力档案信息（表格形式）
export function getArchiveForm(params) {
  return request({
    url: "getArchiveForm",
    method: "get",
    params: params
  });
}

/**
 * * * 入院筛查
 */
// 档案列表管理
export function getPersonArchiveList(data) {
  return request({
    url: "getPersonArchiveList",
    method: "post",
    data: data
  });
}

// 后台查看档案信息
export function getPersonArchive(data) {
  return request({
    url: "getPersonArchive",
    method: "post",
    data: data
  });
}

// 学校筛查历史记录
export function getScreeningList(data) {
  return request({
    url: "getScreeningList",
    method: "get",
    params: data
  });
}

// 筛查进度总览(筛查机构)
export function getScrProgressOverview(params) {
  return request({
    url: "getScrProgressOverview",
    method: "get",
    params: params
  });
}

// 管理-获取筛查计划（下拉选择）
export function getYearItems(data) {
  return request({
    url: "getYearItems",
    method: "post",
    data: data
  });
}

// 任务指派-查询用户账号下的筛查机构
export function getScreeningInstitutionList(params) {
  return request({
    url: "getScreeningInstitutionList",
    method: "get",
    params: params
  });
}

// 任务指派-添加任务指派
export function insterTaskDesignate(data) {
  return request({
    url: "insterTaskDesignate",
    method: "post",
    data: data
  });
}

// 任务指派-查询任务指派
export function getTaskDesignateList(params) {
  return request({
    url: "getTaskDesignateList",
    method: "get",
    params: params
  });
}
// 任务指派-查询任务指派
export function getTaskReminderRecordList(params) {
  return request({
    url: "getTaskReminderRecordList",
    method: "get",
    params: params
  });
}
export function getPCDSchoolDataAnalysis(data) {
  return request({
    url: "getPCDSchoolDataAnalysis",
    method: "post",
    data: data
  });
}

// 筛查机构-重要通知-查询重要通知
export function getMportantNoticeList(data) {
  return request({
    url: "getMportantNoticeList",
    method: "post",
    data: data
  });
}

// 学校-重要通知-查询重要通知
export function getSchoolMportantNoticeList(data) {
  return request({
    url: "getSchoolMportantNoticeList",
    method: "post",
    data: data
  });
}

// 更新任务状态（已读）
export function updateTaskState(params) {
  return request({
    url: "updateTaskState",
    method: "get",
    params: params
  });
}

// 筛查机构-发送通知-筛查前通知确认发送
export function sendPreScreeningNotification(data) {
  return request({
    url: "sendPreScreeningNotification",
    method: "post",
    data: data
  });
}

// 筛查机构-发送通知-筛查后结果通知
export function sendPostScreeningNotification(data) {
  return request({
    url: "sendPostScreeningNotification",
    method: "post",
    data: data
  });
}

// 筛查机构-发送通知-家长短信通知随访
export function sendSMSReminder(data) {
  return request({
    url: "sendSMSReminder",
    method: "post",
    data: data
  });
}
// 筛查机构-筛查进度列表
export function getScrProgress(params) {
  return request({
    url: "getScrProgress",
    method: "get",
    params: params
  });
}
// 筛查进度列表(管理机构)
export function getGovProgress(data) {
  return request({
    url: "getGovProgress",
    method: "get",
    params: data
  });
}

// 管理机构筛查进度（省、市）
export function getGovProgress2(data) {
  return request({
    url: "getGovProgress2",
    method: "get",
    params: data
  });
}
// 管理机构筛查进度（省、市）安阳专用
export function getGovProgress3(data) {
  return request({
    url: "getGovProgress3",
    method: "get",
    params: data
  });
}

// 管理机构获取学校筛查进度列表
export function getGovSchoolProgress2(data) {
  return request({
    url: "getGovSchoolProgress2",
    method: "get",
    params: data
  });
}

// 获取学校年级筛查进度列表
export function getGovGradeProgress2(data) {
  return request({
    url: "getGovGradeProgress2",
    method: "post",
    data: data
  });
}

// 筛查机构获取学校筛查进度列表
export function getScrProgress2(data) {
  return request({
    url: "getScrProgress2",
    method: "get",
    params: data
  });
}

// 学校完成状况名单Excel下载
export function exportSchoolWCZKExcel(data) {
  return request({
    url: "exportSchoolWCZKExcel",
    method: "post",
    data: data
  });
}

// 学生未完成状况名单Excel下载
export function exportStudentWCZKExcel(data) {
  return request({
    url: "exportStudentWCZKExcel",
    method: "post",
    data: data
  });
}

// 机构回复重要通知
export function replyImportantNotice(data) {
  return request({
    url: "replyImportantNotice",
    method: "post",
    data: data
  });
}
// 筛查进度任务提醒
export function screeningProgressTaskReminder(params) {
  return request({
    url: "screeningProgressTaskReminder",
    method: "get",
    params: params
  });
}
// 机构查询单条通知获得回复消息
export function importantNoticeReplyDetail(params) {
  return request({
    url: "importantNoticeReplyDetail",
    method: "get",
    params: params
  });
}
// 图片下载
export function uploadPictureDown(data) {
  return request({
    url: "uploadPictureDown",
    method: "post",
    data: data
  });
}

// 根据通知类型获取通知列表
export function getNotificationListByType(data) {
  return request({
    url: "getNotificationListByType",
    method: "post",
    data: data
  });
}

// 根据token获取对应账号的重要通知列表
export function getImportantNoticeListByToken(params) {
  return request({
    url: "getImportantNoticeListByToken",
    method: "get",
    params: params
  });
}
// 获取短信状态总览
export function getShortMessageDataOverview(params) {
  return request({
    url: "getShortMessageDataOverview",
    method: "get",
    params: params
  });
}
// getNumberOfStudentsByCondition
export function getNumberOfStudentsByCondition(data) {
  return request({
    url: "getNumberOfStudentsByCondition",
    method: "post",
    data: data
  });
}

// 查询导出学生回执单和学生筛查名单-学生数量
export function batchExportStudentReceiptCount(data) {
  return request({
    url: "batchExportStudentReceiptCount",
    method: "post",
    data: data
  });
}

// 导出学生rec
export function expEpiData(data) {
  return request({
    url: "expEpiData",
    method: "post",
    data: data
  });
}
// 筛查机构导出回执单
export function batchExportStudentReceipt(data) {
  return request({
    url: "batchExportStudentReceipt",
    method: "post",
    data: data
  });
}
// 筛查机构导出学生筛检名单
export function exportStudentScreeningData(data) {
  return request({
    url: "exportStudentScreeningData",
    method: "post",
    data: data
  });
}
// 筛查机构导出学生筛检名单定制
export function getExcelForData(data) {
  return request({
    url: "getExcelForData",
    method: "post",
    data: data
  });
}
// 筛查机构导出学生筛检名单定制 (普瑞版)
export function exportGradeSexSumExcel(data) {
  return request({
    url: "exportGradeSexSumExcel",
    method: "post",
    data: data
  });
}
// 学生常见疾病现场监测报告导出pdf
export function exportCommonDiseasesReportToPdf(data) {
  return request({
    url: "exportCommonDiseasesReport",
    method: "post",
    data: data
  });
}
// 筛查结束后导出ptf
export function exportSchoolScreenPdf(data) {
  return request({
    url: "exportSchoolScreenPdf",
    method: "post",
    data: data
  });
}
// 短信-获取用户对应的短信数据记录
export function getShortMessageDataRecord(params) {
  return request({
    url: "getShortMessageDataRecord",
    method: "get",
    params: params
  });
}
// 购买短信获取二维码链接
export function doWxPayCodeUrl(data) {
  return request({
    url: "doWxPayCodeUrl",
    method: "post",
    data: data
  });
}
// 判断微信是否支付成功
export function getOederByOederId(data) {
  return request({
    url: "getOederByOederId",
    method: "post",
    data: data
  });
}
// 获取往年筛查计划列表
export function getHistoryPlan(params) {
  return request({
    url: "getHistoryPlan",
    method: "get",
    params: params
  });
}
// 确认筛查完毕
export function confirmScreeningComplete(data) {
  return request({
    url: "confirmScreeningComplete",
    method: "post",
    data: data
  });
}
// 走进校园-学校分析
export function reportSchool(data) {
  return request({
    url: "reportSchool",
    method: "post",
    data: data
  });
}
// 筛查机构-数据分析

export function getScreeningInstitutionDataAnalysis(data) {
  return request({
    url: "getScreeningInstitutionDataAnalysis",
    method: "post",
    data: data
  });
}

//  筛查进度列表查看区县 (管理机构)
export function getGovSchoolProgress(data) {
  return request({
    url: "getGovSchoolProgress",
    method: "get",
    params: data
  });
}

// 筛查进度列表查看区县 (管理机构)
export function getStudentScreeningDataCount(data) {
  return request({
    url: "getStudentScreeningDataCount",
    method: "post",
    data: data
  });
}

// 筛查机构导出学生筛查名单

export function expArchives(data) {
  return request({
    url: "expArchives",
    method: "post",
    data: data
  });
}
export function getGovSchoolProgressOverview(params) {
  return request({
    url: "getGovSchoolProgressOverview",
    method: "get",
    params: params
  });
}

// 筛查-删除绑定学校
export function delSchoolByScreening(params) {
  return request({
    url: "delSchoolByScreening",
    method: "get",
    params: params
  });
}
// 筛查-绑定学校
export function editSchoolByScreening(params) {
  return request({
    url: "editSchoolByScreening",
    method: "get",
    params: params
  });
}

// 筛查-绑定学校
export function editGovByScreening(params) {
  return request({
    url: "editGovByScreening",
    method: "get",
    params: params
  });
}

// 筛查-查询区县管理机构下没绑定的学校列表
export function getDCAdministrationSchoolList(params) {
  return request({
    url: "getDCAdministrationSchoolList",
    method: "get",
    params: params
  });
}

// 学校账号  信息查询获取 班级信息列表

export function selectClassInformation(data) {
  return request({
    url: "selectClassInformation",
    method: "post",
    data: data
  });
}

// 新增班级信息

export function createClassInformation(data) {
  return request({
    url: "createClassInformation",
    method: "post",
    data: data
  });
}

// 修改班级信息

export function updateClassInformation(data) {
  return request({
    url: "updateClassInformation",
    method: "post",
    data: data
  });
}

// 删除班级信息

export function deleteClassInformation(data) {
  return request({
    url: "deleteClassInformation",
    method: "post",
    data: data
  });
}

// 获取调查问卷-列表

export function SysSelectQuestionnaire(data) {
  return request({
    url: "SysSelectQuestionnaire",
    method: "post",
    data: data
  });
}

// 管理机构发布文章

export function publishArticles(data) {
  return request({
    url: "publishArticles",
    method: "post",
    data: data
  });
}

// 删除文章

export function editArticleStatus(data) {
  return request({
    url: "editArticleStatus",
    method: "post",
    data: data
  });
}

// 修改文章

export function editArticles(data) {
  return request({
    url: "editArticles",
    method: "post",
    data: data
  });
}

// 导出数据报告
export function getSysPdfanalysis(data) {
  return request({
    url: "getSysPdfanalysis",
    method: "post",
    data: data
  });
}

// 导出数据报告
export function getHtml2Pdf(data) {
  return request({
    url: "Html2Pdf",
    method: "post",
    data: data
  });
}
// 管理机构导出epidata 根据areacode获取学校列表

export function getManageSchoolList(data) {
  return request({
    url: "getManageSchoolList",
    method: "get",
    params: data
  });
}

// 导出文件 获取后台返回数据生成地图图片
export function CreateMapUrlByJs(data) {
  return request({
    url: "CreateMapUrlByJs",
    method: "post",
    data: data
  });
}

// 管理-获取操作日志（下拉选择）
export function getSightLogType(data) {
  return request({
    url: "getSightLogType",
    method: "post",
    data: data
  });
}

// 管理-获取操作日志列表
export function getSightLog(data) {
  return request({
    url: "getSightLog",
    method: "post",
    data: data
  });
}

// 管理-superadmin获取操作日志列表
export function SysgetSightLog(data) {
  return request({
    url: "SysgetSightLog",
    method: "post",
    data: data
  });
}

// 质量控制
// 质控统计
export function getSchoolQualityRecheckSum(data) {
  return request({
    url: "getSchoolQualityRecheckSum",
    method: "post",
    data: data
  });
}
// 质控列表
export function getSchoolQualityRecheckList(data) {
  return request({
    url: "getSchoolQualityRecheckList",
    method: "post",
    data: data
  });
}

// 北京疾控质控统计
export function getSchoolQualityRecheckSum03(data) {
  return request({
    url: "getSchoolQualityRecheckSum03",
    method: "post",
    data: data
  });
}
// 北京疾控质控列表
export function getSchoolQualityRecheckList03(data) {
  return request({
    url: "getSchoolQualityRecheckList03",
    method: "post",
    data: data
  });
}

// 根据筛选计划 学校id 获取班级列表
export function searchRecheckClazz(data) {
  return request({
    url: "searchRecheckClazz",
    method: "post",
    data: data
  });
}

// 获取质控详情
export function getSchoolQualityRecheckById(params) {
  return request({
    url: "getSchoolQualityRecheckById",
    method: "get",
    params: params
  });
}

// 单个添加档案抽取质控人数
export function SetArchiveQualityCheck(params) {
  return request({
    url: "SetArchiveQualityCheck",
    method: "get",
    params: params
  });
}

// 批量导出质量控制ptf
export function exportSchoolQualityRecheckPdf(data) {
  return request({
    url: "exportSchoolQualityRecheckPdf",
    method: "post",
    data: data
  });
}

// 获取调查问卷列表

export function getSightQuestionnaireList(data) {
  return request({
    url: "getSightQuestionnaireList",
    method: "post",
    data: data
  });
}

// 获取调查问卷详情
export function getSightQuestionnaireByQid(data) {
  return request({
    url: "getSightQuestionnaireByQid",
    method: "post",
    data: data
  });
}

// 新增调查问卷(单个)
export function insertQuestionnaire(data) {
  return request({
    url: "insertQuestionnaire",
    method: "post",
    data: data
  });
}
// 编辑修改新增调查问卷

export function insertQuestion(data) {
  return request({
    url: "insertQuestion",
    method: "post",
    data: data
  });
}

// 复制调查问卷
export function CopyQuestionnaireByQid(data) {
  return request({
    url: "CopyQuestionnaireByQid",
    method: "post",
    data: data
  });
}

// 调查问卷统计
export function analysisQuestionnaire(params) {
  return request({
    url: "analysisQuestionnaire",
    method: "get",
    params: params
  });
}
// 调查问卷统计Mark8
export function analysisQuestionnaire2(params) {
  return request({
    url: "analysisQuestionnaire2",
    method: "get",
    params: params
  });
}
// 调查问卷统计乌海
export function analysisQuestionnaire3(params) {
  return request({
    url: "https://m.eyenurse.net/codetrans/analysisQuestionnaire3",
    method: "get",
    params: params
  });
}
// 调查问卷统计乌海（kl）
export function analysisQuestionnaire4(params) {
  return request({
    url: "https://m.eyenurse.net/codetrans/analysisQuestionnaire4",
    method: "get",
    params: params
  });
}

// 获取监测数据列表
export function getEyeHealthWatchData(data) {
  return request({
    url: "getEyeHealthWatchData",
    method: "post",
    data: data
  });
}
// 获取监测数据详情
export function getEyeHealthWatchDataList(data) {
  return request({
    url: "getEyeHealthWatchDataList",
    method: "post",
    data: data
  });
}
// 根据筛查机构查询省市区下面的已筛查地区
export function getScreenAreaList(data) {
  return request({
    url: "getScreenAreaList",
    method: "post",
    data: data
  });
}

// 质控统计
// export function getSchoolQualityRecheckSum(data) {
//   return request({
//     url: 'getSchoolQualityRecheckSum',
//     method: 'post',
//     data
//   });
// }

// 质量控制学校列表
export function getQualityRecheckAnalysis(data) {
  return request({
    url: "getQualityRecheckAnalysis",
    method: "post",
    data: data
  });
}

// 北京疾控质量控制学校列表
export function getQualityRecheckAnalysis03(data) {
  return request({
    url: "getQualityRecheckAnalysis03",
    method: "post",
    data: data
  });
}
// 北京疾控质量控制学校列表--按时间统计
export function getQualityRecheckAnalysisByCheckdate(data) {
  return request({
    url: "getQualityRecheckAnalysisByCheckdate",
    method: "post",
    data: data
  });
}

// 质控列表
// export function getSchoolQualityRecheckList(data) {
//   return request({
//     url: 'getSchoolQualityRecheckList',
//     method: 'post',
//     data
//   });
// }

// 自定义回执单内容提交
export function editEyeSightSchoolCustomReceipt(data) {
  return request({
    url: "editEyeSightSchoolCustomReceipt",
    method: "post",
    data: data
  });
}

// 获取回执单内容
export function getCustomReceiptBySchoolId(data) {
  return request({
    url: "getCustomReceiptBySchoolId",
    method: "post",
    data: data
  });
}

// 恢复回执单默认模板
export function getCustomReceipt(data) {
  return request({
    url: "getCustomReceipt",
    method: "get",
    data: data
  });
}
export function getQuestionnaireAnalysis(data) {
  return request({
    url: "getQuestionnaireAnalysis",
    method: "post",
    data: data
  });
}

// 管理机构获取学校列表
export function getSchoolList(params) {
  return request({
    url: "getSchoolList",
    method: "get",
    params: params
  });
}

// 筛查机构学生视力检查报告单
export function exportScreeningRecord(data) {
  return request({
    // timeout:20*60*1000,
    url: "exportScreeningRecord",
    method: "post",
    data: data
  });
}

// 筛查机构 数据报告配置 专家设备报告

// 数据报告配置列表
export function getReportExpertList(params) {
  return request({
    url: "getReportExpertList",
    method: "get",
    params: params
  });
}

// 数据报告配置编辑
export function editReportExpert(data) {
  return request({
    url: "editReportExpert",
    method: "post",
    data: data
  });
}

// 数据报告验证 所选地区学生是否有数据
export function getDatareportCount(data) {
  return request({
    url: "getDatareportCount",
    method: "post",
    data: data
  });
}

// 学校列表 批量删除学校
export function batchDeleteSchool(data) {
  return request({
    url: "batchDeleteSchool",
    method: "post",
    data: data
  });
}

// 学生档案列表 批量删除学生档案
export function batchDeleteArchive(data) {
  return request({
    url: "batchDeleteArchive",
    method: "post",
    data: data
  });
}

// 批量删除学校学生档案
export function batchDeleteArchiveBySchoolGradeClazz(data) {
  return request({
    url: "batchDeleteArchiveBySchoolGradeClazz",
    method: "post",
    data: data
  });
}

// 批量导入记录列表
export function getImportRecordList(params) {
  return request({
    url: "getImportRecordList",
    method: "get",
    params: params
  });
}

// 筛查计划下学校年级班级查学生信息
export function getStudentList(data) {
  return request({
    url: "getStudentList",
    method: "post",
    data: data
  });
}

// 获取检查报告单自定义内容
export function getReportOther(data) {
  return request({
    url: "getReportOther",
    method: "post",
    data: data
  });
}

// 编辑检查报告单自定义内容
export function editReportOther(data) {
  return request({
    url: "editReportOther",
    method: "post",
    data: data
  });
}

// 筛查机构导入学生档案 提示
export function getImportRecordNotSee(data) {
  return request({
    url: "getImportRecordNotSee",
    method: "post",
    data: data
  });
}

// 筛查机构获取筛查项目配置列表
export function getScreenProgram(data) {
  return request({
    url: "getScreenProgram",
    method: "post",
    data: data
  });
}
// 编辑筛查项配置
export function editScreenProgram(data) {
  return request({
    url: "editScreenProgram",
    method: "post",
    data: data
  });
}
// 查询能导出word 的列表
export function checkCanExportHospitalEnvWord(params) {
  return request({
    url: "checkCanExportHospitalEnvWord",
    method: "get",
    params: params
  });
}
// 确认导出调查问卷
export function exportHospitalEnvtWord(params) {
  return request({
    url: "exportHospitalEnvtWord",
    method: "get",
    params: params
  });
}
// 确认导出调查问卷
export function getQuestionnaireById(params) {
  return request({
    url: "getQuestionnaireById",
    method: "get",
    params: params
  });
}
// 查看已答问卷列表
export function getQuestionnairePaperList(params) {
  return request({
    url: "getQuestionnairePaperList",
    method: "get",
    params: params
  });
}
// 删除已答问卷
export function deleteQuestionnairePaper(params) {
  return request({
    url: "deleteQuestionnairePaper",
    method: "get",
    params: params
  });
}
// pc端查看已答问卷详情
export function getQuestionPaperById(params) {
  return request({
    url: "getQuestionPaperById",
    method: "get",
    params: params
  });
}
// 查看已答心理问卷报告
export function getXlQuestionnaireAnalysis(params) {
  var mbase = process.env.VUE_APP_BASE_API.replace("/sight", "");
  return request({
    baseURL: mbase + "app/account/",
    // 测试
    url: "getXlQuestionnaireAnalysis",
    method: "get",
    params: params
  });
}
// pc端查看已答问卷详情（云）
export function getQuestionPaperById2(params) {
  return request({
    baseURL: "https://api.eyenurse.net/newdeparture/cloud/",
    url: "getQuestionPaperById",
    method: "get",
    params: params
  });
}

// pc端下载数据报告
export function ExportScreenAnalysisNew(data) {
  return request({
    url: "ExportScreenAnalysisNew",
    method: "post",
    data: data
  });
}

// 判断是否有数据
export function getExportScreenAnalysisNewCount(data) {
  return request({
    url: "getExportScreenAnalysisNewCount",
    method: "post",
    data: data
  });
}

// pc端下载数据报告历史
export function getImportRecordListNew(params) {
  return request({
    url: "getImportRecordList",
    method: "get",
    params: params
  });
}

// // 查询全部十五省数据列表
// export function getFifteenArchiveList(data) {
//   return request({
//     url: "getFifteenArchiveList",
//     method: "post",
//     data
//   });
// }
// 查询全部十五省数据列表
export function findFifteenArchiveList(data) {
  return request({
    url: "findFifteenArchiveList",
    method: "post",
    data: data
  });
}
// 下载全部十五省数据列表（已筛查）
export function getFifteenExcelForIBMSPSS(data) {
  return request({
    url: "getFifteenExcelForIBMSPSS",
    method: "post",
    data: data
  });
}
// 十五省虚拟身份证号替换
export function DealSnoByNameInPlanIdSchoolId(data) {
  return request({
    url: "DealSnoByNameInPlanIdSchoolId",
    method: "post",
    data: data
  });
}
// 十五省街道数据总计
export function getFifteenStreetSum(data) {
  return request({
    url: "getFifteenStreetSum",
    method: "post",
    data: data
  });
}
// 十五省街道列表
export function getFifteenStreetList(data) {
  return request({
    url: "getFifteenStreetList",
    method: "post",
    data: data
  });
}
// 十五省年龄列表
export function getFifteenAgeList(data) {
  return request({
    url: "getFifteenAgeList",
    method: "post",
    data: data
  });
}
// 十五省年龄总计
export function getFifteenAgeSum(data) {
  return request({
    url: "getFifteenAgeSum",
    method: "post",
    data: data
  });
}
// 十五省数据统计excel
export function getFifteenSumExcel(data) {
  return request({
    url: "getFifteenSumExcel",
    method: "post",
    data: data
  });
}
// 获取十五省各省配置列表
export function getFifteenSetting(data) {
  return request({
    url: "getFifteenSetting",
    method: "post",
    data: data
  });
}
// 十五省配置修改和添加
export function saveFifteenSetting(data) {
  return request({
    url: "saveFifteenSetting",
    method: "post",
    data: data
  });
}
// 查询社区列表
export function getHospitalNameAndPlanIdFifteen(params) {
  return request({
    url: "getHospitalNameAndPlanIdFifteen",
    method: "get",
    params: params
  });
}
// 查询社区列表
export function getStreets(params) {
  return request({
    url: "getStreets",
    method: "get",
    params: params
  });
}

// 通知管理设置项查询
export function getSightNotice(params) {
  return request({
    url: "getSightNotice",
    method: "get",
    params: params
  });
}

// 通知管理设置项更新
export function updateSightNotice(data) {
  return request({
    url: "updateSightNotice",
    method: "post",
    data: data
  });
}

// 系统通知标记为已读
export function updateDesignateNoticeState(params) {
  return request({
    url: "updateDesignateNoticeState",
    method: "get",
    params: params
  });
}
// 查看疫情病种列表
export function searchInfectiousDisease(params) {
  return request({
    url: "searchInfectiousDisease",
    method: "get",
    params: params
  });
}
// 修改传染病预警阈值
export function updateInfectiousThreshold(data) {
  return request({
    url: "updateInfectiousThreshold",
    method: "post",
    data: data
  });
}
// 新建地区联系人
export function createAreaContacts(data) {
  return request({
    url: "createAreaContacts",
    method: "post",
    data: data
  });
}
// 修改地区联系人
export function updateAreaContacts(data) {
  return request({
    url: "updateAreaContacts",
    method: "post",
    data: data
  });
}
// 删除地区联系人
export function deleteAreaContacts(params) {
  return request({
    url: "deleteAreaContacts",
    method: "get",
    params: params
  });
}
// 查看地区联系人列表
export function listAreaContacts(params) {
  return request({
    url: "listAreaContacts",
    method: "get",
    params: params
  });
}
// 修改短信通知设置
export function updateShortMessageSetting(data) {
  return request({
    url: "updateShortMessageSetting",
    method: "post",
    data: data
  });
}
// 修改预警指标
export function updateEarlyWarningIndex(data) {
  return request({
    url: "updateEarlyWarningIndex",
    method: "post",
    data: data
  });
}

// 查看地区设置(预警指标及短信通知)
export function getAreaSetting(params) {
  return request({
    url: "getAreaSetting",
    method: "get",
    params: params
  });
}
// 查看患者详情
export function getInfectiousDiseasesInfo(params) {
  return request({
    url: "getInfectiousDiseasesInfo",
    method: "get",
    params: params
  });
}
// 查看传染病下拉
export function getInfectiousDiseaseList(params) {
  return request({
    url: "getInfectiousDiseaseList",
    method: "get",
    params: params
  });
}
// 查看市级请假统计
export function listCityLeaveStatistics(data) {
  return request({
    url: "listCityLeaveStatistics",
    method: "post",
    data: data
  });
}
// 查看市区学校班级总请假统计
export function getLeaveSumStatistics(data) {
  return request({
    url: "getLeaveSumStatistics",
    method: "post",
    data: data
  });
}
// 查看区县请假统计
export function listDistrictLeaveStatistics(data) {
  return request({
    url: "listDistrictLeaveStatistics",
    method: "post",
    data: data
  });
}
// 查看学校请假统计
export function listSchoolLeaveStatistics(data) {
  return request({
    url: "listSchoolLeaveStatistics",
    method: "post",
    data: data
  });
}
// 查看班级请假统计
export function listClazzLeaveStatistics(data) {
  return request({
    url: "listClazzLeaveStatistics",
    method: "post",
    data: data
  });
}
// 查看市级传染病统计
export function listCityDiseaseStatistics(data) {
  return request({
    url: "listCityDiseaseStatistics",
    method: "post",
    data: data
  });
}
// 查看区级传染病统计
export function listDistrictDiseaseStatistics(data) {
  return request({
    url: "listDistrictDiseaseStatistics",
    method: "post",
    data: data
  });
}
// 查看学校传染病统计
export function listSchoolDiseaseStatistics(data) {
  return request({
    url: "listSchoolDiseaseStatistics",
    method: "post",
    data: data
  });
}
// 查看班级传染病统计
export function listClazzDiseaseStatistics(data) {
  return request({
    url: "listClazzDiseaseStatistics",
    method: "post",
    data: data
  });
}
// 查看市区学校班级总传染病统计
export function getDiseaseSumStatistics(data) {
  return request({
    url: "getDiseaseSumStatistics",
    method: "post",
    data: data
  });
}

// 查看市区学校班级总传染病统计
export function expSightBehavior(data) {
  return request({
    url: "expSightBehavior",
    method: "post",
    data: data
  });
}
// 使用rec/spss生成数据报告
export function importSpssFile(data) {
  return request({
    url: "importSpssFile",
    method: "post",
    data: data
  });
}
// 下载数据报告word版
export function expSightWordExport(data) {
  return request({
    url: "expSightWordExport",
    method: "post",
    data: data
  });
}

// 下载新版数据报告
export function NewPDFReport(data) {
  return request({
    url: "NewPDFReport",
    method: "post",
    data: data
  });
}

// 获取街道——社区楼号列表 学校id
export function getStreetVillageBuildingList(params) {
  return request({
    url: "getStreetVillageBuildingList",
    method: "get",
    params: params
  });
}
// 删除街道——社区楼号
export function delVillageBuilding(data) {
  return request({
    url: "delVillageBuilding",
    method: "post",
    data: data
  });
}
// 修改街道——社区楼号
export function editVillageBuilding(data) {
  return request({
    url: "editVillageBuilding",
    method: "post",
    data: data
  });
}
// 修改街道——社区楼号
export function listDocument(data) {
  return request({
    url: "listDocument",
    method: "post",
    data: data
  });
}
// 学校获取年级 班级数 学生数
export function getSchoolGradeCodeClazzStuList(data) {
  return request({
    url: "getSchoolGradeCodeClazzStuList",
    method: "post",
    data: data
  });
}
// 年级获取班级 学生数
export function getClazzStuList(data) {
  return request({
    url: "getClazzStuList2",
    method: "post",
    data: data
  });
}
// 班级获取 学生列表
export function getStuList(data) {
  return request({
    url: "getStuList2",
    method: "post",
    data: data
  });
}
// demo演示用
export function getOwner(data) {
  return request({
    url: "getOwner",
    method: "post",
    data: data
  });
}
// 学生档案升学情况
export function copyArchiveListByPlanId(data) {
  return request({
    url: "copyArchiveListByPlanId",
    method: "post",
    data: data
  });
}
// 批量修改班级信息
export function updateClazzFromOldToNew(data) {
  return request({
    url: "updateClazzFromOldToNew",
    method: "post",
    data: data
  });
}
// 批量修改学生班级信息
export function updateStudentFromOldToNew(data) {
  return request({
    url: "updateStudentFromOldToNew",
    method: "post",
    data: data
  });
}
// 短信-查询订单是否支付成功
export function getOrderByOrderId(params) {
  return request({
    url: "getOrderByOrderId",
    method: "get",
    params: params
  });
}
// 筛查计划下学校是否确认完成筛查
export function getIsCheckdata(params) {
  return request({
    url: "getIsCheckdata",
    method: "get",
    params: params
  });
}
// 确认筛查完成
export function confirmCheckdata(params) {
  return request({
    url: "confirmCheckdata",
    method: "get",
    params: params
  });
}
// 查询确认筛查完成数据
export function getCheckdataTotal(data) {
  return request({
    url: "getCheckdataTotal",
    method: "post",
    data: data
  });
}
// 查询确认筛查完成数据
export function exportSchoolExcel(data) {
  return request({
    url: "exportSchoolExcel",
    method: "post",
    data: data
  });
}
// 查询学校可下载人数
export function getSchools2(params) {
  return request({
    url: "getSchools2",
    method: "get",
    params: params
  });
}
// 数据报告配置编辑接口
export function editEyeSightUserNum(data) {
  return request({
    url: "editEyeSightUserNum",
    method: "post",
    data: data
  });
}
// 数据报告配置获取接口
export function getEyeSightUserNum(params) {
  return request({
    url: "getEyeSightUserNum",
    method: "get",
    params: params
  });
}
// 学校查询班主任列表
export function getTeacherList(params) {
  return request({
    url: "getTeacherList",
    method: "get",
    params: params
  });
}
// 批量修改班主任权限信息及升年级
export function updateTeacherFromOldToNew(data) {
  return request({
    url: "updateTeacherFromOldToNew",
    method: "post",
    data: data
  });
}
// 下载学生体质不良数据
export function exportStudentScreeningData2(data) {
  return request({
    url: "exportStudentScreeningData2",
    method: "post",
    data: data
  });
}
// 下载中小学生健康体检单
export function batchExportStudentHealthForm(data) {
  return request({
    url: "batchExportStudentHealthForm",
    method: "post",
    data: data
  });
}
// 广西迁移接口开始
// 学校是否参与数据统计
export function setSchoolAdminMissAnalysis(data) {
  return request({
    url: "setSchoolMissAnalysis",
    method: "post",
    data: data
  });
}

// 区县级管理机构获取关联学校列表
export function getSchoolListByAreaCode2(data) {
  return request({
    url: "getSchoolListByAreaCode2",
    method: "post",
    data: data
  });
}
// 区县级管理机构获取有关联的筛查机构列表
export function getScreenListByAreaCode2(data) {
  return request({
    url: "getScreenListByAreaCode2",
    method: "post",
    data: data
  });
}
// 获取常见病档案信息
export function getArchiveForm2(params) {
  return request({
    url: "getArchiveForm2",
    method: "get",
    params: params
  });
}
// 批量删除学生档案
export function deleteArchiveList(data) {
  return request({
    url: "deleteArchiveList",
    method: "post",
    data: data
  });
}
// 区县级管理机构列表、
export function getScreenInstitution(params) {
  return request({
    url: "getScreenInstitution",
    method: "get",
    params: params
  });
}

// 区县级管理机构列表、
export function getJyScreenInstitution(params) {
  return request({
    url: "getJyScreenInstitution",
    method: "get",
    params: params
  });
}

// 导出筛查进度
export function exportScrProgress(data) {
  return request({
    url: "exportScrProgress",
    method: "post",
    data: data
  });
}
// 批量导出质量控制ptf
export function exportQualityRecheckAnalysisExcel(data) {
  return request({
    url: "exportQualityRecheckAnalysisExcel",
    method: "post",
    data: data
  });
}
// 广西迁移接口结束

// 下载调查问卷记录表
export function exportQuestionnaireRecord(data) {
  return request({
    url: "expQuesExcel",
    method: "post",
    data: data
  });
}

// 获取账户列表
export function accountList2(data) {
  return request({
    url: "accountList2",
    method: "post",
    data: data
  });
}
// 调查问卷可绑定列表查询（仅支持表四）
export function getQuestionnaireMarkList(params) {
  return request({
    url: "getQuestionnaireMarkList",
    method: "get",
    params: params
  });
}
// 调查问卷可绑定列表查询（支持表四和厦门心理问卷）
export function getQuestionnaireMarkList2(params) {
  return request({
    url: "getQuestionnaireMarkList2",
    method: "get",
    params: params
  });
}
// 调查问卷绑定
export function tieQuestionnaireGroupId(params) {
  return request({
    url: "tieQuestionnaireGroupId",
    method: "get",
    params: params
  });
}
// 调查问卷解绑
export function clearQuestionnaireGroupId(params) {
  return request({
    url: "clearQuestionnaireGroupId",
    method: "get",
    params: params
  });
}
// 筛查进度根据学校完成情况查看学校列表
export function getGovSchoolWithType(params) {
  return request({
    url: "getGovSchoolWithType",
    method: "get",
    params: params
  });
}
// 删除上传下载记录表记录
export function updateImportRecordIsDelete(params) {
  return request({
    url: "updateImportRecordIsDelete",
    method: "get",
    params: params
  });
}

// 筛查机构导出学生筛检名单
export function exportSchoolPdf(data) {
  return request({
    url: "exportSchoolPdf",
    method: "post",
    data: data
  });
}

// 计划类型统计列表
export function planCountList(params) {
  return request({
    url: "planCountList",
    method: "get",
    params: params
  });
}

// 批量删除计划
export function delPlan(data) {
  return request({
    url: "delPlan",
    method: "post",
    data: data
  });
}

// 学校类型统计数量
export function schoolCountList(params) {
  return request({
    url: "schoolCountList",
    method: "get",
    params: params
  });
}

// 街道社区楼号统计
export function streetCountList(params) {
  return request({
    url: "streetCountList",
    method: "get",
    params: params
  });
}

// 档案统计
export function getHospitalScreenCount(params) {
  return request({
    url: "getHospitalScreenCount",
    method: "get",
    params: params
  });
}

// 下载异常学生名单
export function getAbnormalsStudentExcel(data) {
  return request({
    url: "getAbnormalsStudentExcel",
    method: "post",
    data: data
  });
}

// 获取新四位编码
export function getNewArchiveCode(data) {
  return request({
    url: "getNewArchiveCode",
    method: "post",
    data: data
  });
}

// 筛查进度省市统计接口
export function getGovProgressOverview2(params) {
  return request({
    url: "getGovProgressOverview2",
    method: "get",
    params: params
  });
}

// 筛查进度省市统计接口安阳专用
export function getGovProgressOverview3(params) {
  return request({
    url: "getGovProgressOverview3",
    method: "get",
    params: params
  });
}

// 筛查进度省市统计接口
export function getGovSchoolProgressOverview2(params) {
  return request({
    url: "getGovSchoolProgressOverview2",
    method: "get",
    params: params
  });
}

// 筛查机构获取学校筛查进度列表
export function getScrProgressOverview2(params) {
  return request({
    url: "getScrProgressOverview2",
    method: "get",
    params: params
  });
}

// 筛查机构根据计划和学校获取筛查项目配置列表
export function getScreenProgram2(params) {
  return request({
    url: "getScreenProgram2",
    method: "get",
    params: params
  });
}

// 根据计划和学校编辑筛查项配置
export function editScreenProgramByPlanIdSchoolId(data) {
  return request({
    url: "editScreenProgramByPlanIdSchoolId",
    method: "post",
    data: data
  });
}

// 下载学生基础数据
export function getBaseStudentExcel(data) {
  return request({
    url: "getBaseStudentExcel",
    method: "post",
    data: data
  });
}

// 导出问卷8(Excel格式)
export function exportQuestionnaire(params) {
  return request({
    url: "exportQuestionnaire",
    method: "get",
    params: params
  });
}

// 下载家长告知书
export function getParentNoticePdf(data) {
  return request({
    url: "getParentNoticePdf",
    method: "post",
    data: data
  });
}

// 数据审核
export function getBaseCheckStudentExcel(data) {
  return request({
    url: "getBaseCheckStudentExcel",
    method: "post",
    data: data
  });
}

// 获取管理机构绑定计划
export function getParentIdAndPlanId(params) {
  return request({
    url: "getParentIdAndPlanId",
    method: "get",
    params: params
  });
}

//  图片上传（可裁剪）
export function uploadCutFile(data) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return request(_objectSpread({
    url: "uploadCutFile",
    method: "post",
    data: data
  }, config));
}

//  rec、sav文件上传data中含区域ID
export function uploadDataFile(data) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return request(_objectSpread({
    url: "uploadDataFile",
    method: "post",
    data: data
  }, config));
}

// 下载原测复测数据
export function exportSchoolYSCBPdf(data) {
  return request({
    url: "exportSchoolYSCBPdf",
    method: "post",
    data: data
  });
}

// 远视力监测点同意书统计列表
export function tysPointList(data) {
  return request({
    url: "tysPointList",
    method: "post",
    data: data
  });
}

// 远视力学校同意书统计列表
export function tysSchoolList(data) {
  return request({
    url: "tysSchoolList",
    method: "post",
    data: data
  });
}

// 远视力获取监测点列表
export function getPointSchoollist(params) {
  return request({
    url: "getPointSchoollist",
    method: "get",
    params: params
  });
}

// 远视力获取学校列表
export function getYSLSchoolList(data) {
  return request({
    url: "searchSchool",
    method: "post",
    data: data
  });
}

// 远视力下载未完成名单
export function getYSCBExcel(data) {
  return request({
    url: "getYSCBExcel",
    method: "post",
    data: data
  });
}

// 远视力报告单导出
export function getPdfForBeiDaData(data) {
  return request({
    url: "getPdfForBeiDaData",
    method: "post",
    data: data
  });
}

// 远视力报告单导出
export function getYSCBScreenExcel(data) {
  return request({
    url: "getYSCBScreenExcel",
    method: "post",
    data: data
  });
}

// 下载完成进度
export function getBJJKExcel(data) {
  return request({
    url: "getBJJKExcel",
    method: "post",
    data: data
  });
}

// 同仁项目-查询推送统计
export function getInspectCountTotal(params) {
  return request({
    url: "/inspect/getInspectCountTotal",
    method: "get",
    params: params
  });
}

// 同仁项目-查询订阅用户
export function getInspectKidList2(data) {
  return request({
    url: "/inspect/getInspectKidList2",
    method: "post",
    data: data
  });
}

// 同仁项目-查询检查结果详情
export function getResultById(params) {
  return request({
    url: "/inspect/getResultById2",
    method: "get",
    params: params
  });
}

// 视力测试-查询孩子训练结果----分页
export function getKidTrainResults(params) {
  return request({
    url: "/inspect/getKidTrainResults",
    method: "get",
    params: params
  });
}

// 同仁项目-获取参与近视项目学校
export function getInspectKidSchool(params) {
  return request({
    url: "/inspect/getInspectKidSchool",
    method: "get",
    params: params
  });
}

// 筛查机构下载国家重大专项课题数据表
export function exportMajorNationProjectData(data) {
  return request({
    url: "exportMajorNationProjectData",
    method: "post",
    data: data
  });
}

// 下载儿童青少年近视调查结果统计表（旧）
export function exportJstjbWord(data) {
  return request({
    url: "exportJstjbWord",
    method: "post",
    data: data
  });
}

// 下载儿童青少年近视调查结果统计表（新）
export function exportXztjbExcel(data) {
  return request({
    url: "exportXztjbExcel",
    method: "post",
    data: data
  });
}

// 下载教学环境监测表
export function expMark1Excel(data) {
  return request({
    url: "expMark1Excel",
    method: "post",
    data: data
  });
}

// 下载学生近视发生发展相关因素调查表
export function getBaseStudentExcelWithQues(data) {
  return request({
    url: "getBaseStudentExcelWithQues",
    method: "post",
    data: data
  });
}

// 下载知情同意书
export function exportZqtysPdf(data) {
  return request({
    url: "exportZqtysPdf",
    method: "post",
    data: data
  });
}

// 下载家长查询结果
export function exportJzcxPdf(data) {
  return request({
    url: "exportJzcxPdf",
    method: "post",
    data: data
  });
}

// 下载表1-3现场情况表
export function expSightSchoolWordExport(data) {
  return request({
    url: "expSightSchoolWordExport",
    method: "post",
    data: data
  });
}

// 下载远视力储备下载未完成学生名单
export function exportYscbWwcExcel(data) {
  return request({
    url: "exportYscbWwcExcel",
    method: "post",
    data: data
  });
}

// 下载营养问卷表
export function exportXzYywjExcel(data) {
  return request({
    url: "/exportXzYywjExcel",
    method: "post",
    data: data
  });
}

// 下载表4增加部分数据
export function exportBeiJingTable4Excel(data) {
  return request({
    url: "/exportBeiJingTable4Excel",
    method: "post",
    data: data
  });
}

// 下载学生视力检查告知书
export function exportStuCheckNoticeWord(data) {
  return request({
    url: "exportStuCheckNoticeWord",
    method: "post",
    data: data
  });
}
// 筛查进度-查询市级统计和各区统计
export function getGovProgressOverviewByDate(params) {
  return request({
    url: "getGovProgressOverviewByDate",
    method: "get",
    params: params
  });
}
// 恢复家长告知书模板为默认模板,机构自定义模板会被删除
export function recoverToDefaultNotice(data) {
  return request({
    url: "recoverToDefaultNotice",
    method: "post",
    data: data
  });
}

// 保存家长告知书自定义模板
export function editEyeSightSchoolCustomNotice(data) {
  return request({
    url: "editEyeSightSchoolCustomNotice",
    method: "post",
    data: data
  });
}

// 保存家长告知书自定义模板
export function getCustomNoticeBySchoolId(data) {
  return request({
    url: "getCustomNoticeBySchoolId",
    method: "post",
    data: data
  });
}

// 学生未完成问卷名单Excel下载
export function screenDownload(data) {
  return request({
    url: "screen/student/screenDownload",
    method: "post",
    data: data
  });
}
// 筛查进度-查询市级统计和各区统计
export function deleteCdcKey(params) {
  return request({
    url: "deleteCdcKey",
    method: "get",
    params: params
  });
}

// 选择筛查机构接口(远视力下载未完成名单使用)
export function planSonList(params) {
  return request({
    url: "planSonList",
    method: "get",
    params: params
  });
}

// 选择学校接口(远视力下载未完成名单使用)
export function planSchoolList(params) {
  return request({
    url: "planSchoolList",
    method: "get",
    params: params
  });
}

// 查看学生档案体检表
export function getTiJianTableByArchiveId(params) {
  return request({
    url: "question/dictionary/getTiJianTableByArchiveId",
    method: "get",
    params: params
  });
}

// 学生档案管理中修改体检时间按钮的获取学校列表接口
export function getSightSchoolList(params) {
  return request({
    url: '/ExamDategetSightSchoolList',
    method: 'get',
    params: params
  });
}

// 学生档案管理中修改体检时间按钮的获取年级列表
export function searchClazz(params) {
  return request({
    url: '/ExamDatesearchClazz',
    method: 'get',
    params: params
  });
}

// 学生档案管理中修改体检时间按钮的获取班级列表
export function searchClazz1(params) {
  return request({
    url: '/ExamDatesearchClazz1',
    method: 'get',
    params: params
  });
}

// 修改体检日期
export function updateExamDate(data) {
  return request({
    url: "updateExamDate",
    method: "post",
    data: data
  });
}
// 任务指派-查询用户账号下的筛查机构
export function getScreeningInstitutionList4school(params) {
  return request({
    url: "getScreeningInstitutionList4school",
    method: "get",
    params: params
  });
}
// 根据学生信息几个参数查该学生已答问卷
export function getQuestionPaperByStuInfo(params) {
  return request({
    url: "getQuestionPaperByStuInfo",
    method: "get",
    params: params
  });
}